import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '@env/environment'
import { Observable, catchError, map, of } from 'rxjs'

import { CobranzaMonthlySummary } from '../../interfaces/monthly-summary.interface'

type Wrapped<T> = { error: boolean; msg: string; data: T | null }

/** Lo que Cobranza necesita de la API a nivel de PANTALLA, no de una de sus vistas. */
@Injectable({ providedIn: 'root' })
export class ApiCobranzaService {
	private readonly http = inject(HttpClient)

	/**
	 * El embudo del mes. Sin `month` responde el mes en curso, y el servidor devuelve el que usó —la
	 * pantalla pinta ese, no el que creía haber pedido.
	 */
	monthlySummary(month?: string): Observable<Wrapped<CobranzaMonthlySummary>> {
		const query = month ? `?month=${month}` : ''

		return this.http.get(`${environment.apiUrl}payments/monthly-summary${query}`).pipe(
			map((r) => r as Wrapped<CobranzaMonthlySummary>),
			catchError((e) => of({ error: true, msg: e?.error?.msg || 'No se pudo cargar el resumen del mes', data: null }))
		)
	}
}
